import { Row } from 'antd';
import styled from 'styled-components';

import { Form } from '@form/common.style';

export const BodyWrapper = styled(Row)`
  flex: 1;
  overflow-y: auto;
  padding-bottom: 16px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`;

export const FormWrapper = styled(Form)`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const FormItem = styled(Form.Item)`
  flex: 1;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
